import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import DocumentTitle from 'react-document-title';
import { BrowserRouter, Route, Switch, Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import React from 'react';
import { FaClock, FaMapMarkerAlt, FaPhone } from 'react-icons/fa';
import Khram from './pages/khram';
import Navig from './componenti/nav';
import MainPage from './pages/main';
import Photo from './pages/photo';
import Donate from './pages/donate';
import Build from './pages/building';

function App() {
  return (
    <DocumentTitle title="Храм Даховская">
      <div className="site-shell">
        <BrowserRouter basename="/">
          <Switch>
            <Route exact path="/">
              <Navig />
              <MainPage />
            </Route>
            <Route exact path="/khram">
              <Navig />
              <Khram />
            </Route>
            <Route exact path="/photo">
              <Navig />
              <Photo />
            </Route>
            <Route exact path="/donate">
              <Navig />
              <Donate />
            </Route>
            <Route exact path="/building">
              <Navig />
              <Build />
            </Route>
          </Switch>

          <footer className="site-footer">
            <Container>
              <Row className="g-4">
                <Col lg={5}>
                  <h3 className="footer-title">Свято-Георгиевский храм</h3>
                  <p className="footer-text">
                    Станица Даховская, Майкопский район, ул. Клубная, 16А.
                    Добро пожаловать на богослужения и приходские события.
                  </p>
                </Col>
                <Col sm={6} lg={4}>
                  <div className="footer-list">
                    <span className="footer-item"><FaPhone /> +7 (918) 424-93-95</span>
                    <span className="footer-item"><FaMapMarkerAlt /> ул. Клубная, 16А</span>
                    <span className="footer-item">
                      <FaClock /> СБ: 14:00 Панихида, 16:00 Вечерняя; ВС: 7:30 Исповедь, 8:00 Литургия
                    </span>
                  </div>
                </Col>
                <Col sm={6} lg={3}>
                  <div className="footer-links">
                    <Link to="/">Главная</Link>
                    <Link to="/photo">Фотогалерея</Link>
                    <Link to="/building">Строительство</Link>
                    <Link to="/donate">Пожертвования</Link>
                  </div>
                </Col>
              </Row>
            </Container>
          </footer>
        </BrowserRouter>
      </div>
    </DocumentTitle>
  );
}

export default App;
